/*
 * @Author: Ashley.Liu
 * @Date: 2022-03-14 13:36:10
 * @LastEditTime: 2022-05-09 13:39:00
 * @Description: desc
 */
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import historyItems from './historyItems'
import multiTabs from './multiTabs'
import dictionarys from './dictionarys'
import globalconfig from './globalconfig'
Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  modules: ['historyItems']
})

const vuexSession = new VuexPersistence({
  storage: window.sessionStorage,
  modules: ['dictionarys', 'multiTabs']
})

const store = new Vuex.Store({
  modules: {
    historyItems,
    multiTabs,
    dictionarys,
    globalconfig
  },
  plugins: [vuexLocal.plugin, vuexSession.plugin]
})

export default store
